import {
  CExpandedCtaSection,
  CExpandedCtaSectionBlock,
} from './c-expanded-cta-section'
import { CCtaColumns } from './c-cta-columns'
import { CraftLinkItField } from 'tsconfig/craft-types'

type Props = {
  field: Array<CExpandedCtaSectionBlock>
}

export const CExpandedCtaSectionES = ({ field }: Props) => {
  if (!field?.length) return null

  const [first, ...rest] = field

  const columnsField =
    rest.length > 0
      ? [
          {
            buttons: rest.map((b) => ({
              heading: b.heading,
              cta: (b.cta as CraftLinkItField) ?? undefined,
            })),
          },
        ]
      : []

  return (
    <>
      <CExpandedCtaSection field={[first]} />
      {columnsField.length > 0 && <CCtaColumns field={columnsField as any} />}
    </>
  )
}
